export const dummyAnnexuresList = [
  {
    "header": {
      "content": [
        {
          "key": "1",
          "type": {
            "field": "textbox",
            "editable": true,
            "label": "Candidate Name",
            "validator": {
              "is_required": true,
              "min_len": 3,
              "max_len": 20
            },
            "prefix": null,
            "suffix": null
          },
          "childs": null
        },
        {
          "key": "2",
          "type": {
            "field": "void",
            "label": "Gender",
            "validator": null,
            "prefix": null,
            "suffix": null
          },
          "childs": [
            {
              "key": "2.1",
              "type": {
                "field": "dropdown",
                "editable": true,
                "label": "Male",
                "options": ["YES", "NO"],
                "validator": { "is_required": true },
                "prefix": null,
                "suffix": null
              },
              "childs": null
            },
            {
              "key": "2.2",
              "type": {
                "field": "dropdown",
                "editable": true,
                "label": "Female",
                "options": ["YES", "NO"],
                "validator": { "is_required": true },
                "prefix": null,
                "suffix": null
              },
              "childs": null
            }
          ]
        },
        {
          "key": "3",
          "type": {
            "field": "textbox",
            "editable": true,
            "label": "Age",
            "validator": {
              "is_required": true,
              "is_integer": true,
              "min": 18.0,
              "max": 60.0
            },
            "prefix": null,
            "suffix": "Years"
          },
          "childs": null
        },
        {
          "key": "4",
          "type": {
            "field": "datepicker",
            "editable": true,
            "label": "Date Of Birth",
            "validator": {
              "is_required": true,
              "max": 946665000
            },
            "prefix": null,
            "suffix": null
          },
          "childs": null
        },
        {
          "key": "5",
          "type": {
            "field": "void",
            "label": "Document",
            "validator": null,
            "prefix": null,
            "suffix": null
          },
          "childs": [
            {
              "key": "5.1",
              "type": {
                "field": "attachment",
                "editable": true,
                "label": "Photo",
                "validator": {
                  "is_required": false,
                  "multiple": true,
                  "formats": ["png", "jpeg", "jpg"]
                },
                "prefix": null,
                "suffix": null
              },
              "childs": null
            },
            {
              "key": "5.2",
              "type": {
                "field": "attachment",
                "editable": true,
                "label": "Resume",
                "validator": {
                  "is_required": true,
                  "multiple": false,
                  "formats": ["pdf"]
                },
                "prefix": null,
                "suffix": null
              },
              "childs": null
            }
          ]
        }
      ]
    },
    "aggrigator": {
      "keys": ["3"],
      "type": "sum"
    },
    "is_growable": true,
    "name": "Recruitment Data",
    "code": "A17"
  },
  {
    "header": {
      "content": [
        {
          "key": "1",
          "type": {
            "field": "textbox",
            "editable": true,
            "label": "Candidate Name",
            "validator": {
              "is_required": true,
              "min_len": 3,
              "max_len": 20
            },
            "prefix": null,
            "suffix": null
          },
          "childs": null
        },
        {
          "key": "2",
          "type": {
            "field": "void",
            "label": "Gender",
            "validator": null,
            "prefix": null,
            "suffix": null
          },
          "childs": [
            {
              "key": "2.1",
              "type": {
                "field": "dropdown",
                "editable": true,
                "label": "Male",
                "options": ["YES", "NO"],
                "validator": { "is_required": true },
                "prefix": null,
                "suffix": null
              },
              "childs": null
            },
            {
              "key": "2.2",
              "type": {
                "field": "dropdown",
                "editable": true,
                "label": "Female",
                "options": ["YES", "NO"],
                "validator": { "is_required": true },
                "prefix": null,
                "suffix": null
              },
              "childs": null
            }
          ]
        },
        {
          "key": "3",
          "type": {
            "field": "textbox",
            "editable": true,
            "label": "Age",
            "validator": {
              "is_required": true,
              "is_integer": true,
              "min": 18.0,
              "max": 60.0
            },
            "prefix": null,
            "suffix": "Years"
          },
          "childs": null
        },
        {
          "key": "4",
          "type": {
            "field": "datepicker",
            "editable": true,
            "label": "Date Of Birth",
            "validator": {
              "is_required": true,
              "max": 946665000
            },
            "prefix": null,
            "suffix": null
          },
          "childs": null
        },
        {
          "key": "5",
          "type": {
            "field": "void",
            "label": "Document",
            "validator": null,
            "prefix": null,
            "suffix": null
          },
          "childs": [
            {
              "key": "5.1",
              "type": {
                "field": "attachment",
                "editable": true,
                "label": "Photo",
                "validator": {
                  "is_required": false,
                  "multiple": true,
                  "formats": ["png", "jpeg", "jpg"]
                },
                "prefix": null,
                "suffix": null
              },
              "childs": null
            },
            {
              "key": "5.2",
              "type": {
                "field": "attachment",
                "editable": true,
                "label": "Resume",
                "validator": {
                  "is_required": true,
                  "multiple": false,
                  "formats": ["pdf"]
                },
                "prefix": null,
                "suffix": null
              },
              "childs": null
            }
          ]
        }
      ]
    },
    "aggrigator": {
      "keys": ["3"],
      "type": "sum"
    },
    "is_growable": false,
    "name": "Recruitment Data",
    "code": "A18"
  },
  {
    "header": {
      "content": [
        {
          "key": "1",
          "type": {
            "field": "textbox",
            "editable": true,
            "label": "Candidate Name",
            "validator": {
              "is_required": true,
              "min_len": 3,
              "max_len": 20
            },
            "prefix": null,
            "suffix": null
          },
          "childs": null
        },
        {
          "key": "2",
          "type": {
            "field": "void",
            "label": "Gender",
            "validator": null,
            "prefix": null,
            "suffix": null
          },
          "childs": [
            {
              "key": "2.1",
              "type": {
                "field": "dropdown",
                "editable": true,
                "label": "Male",
                "options": ["YES", "NO"],
                "validator": { "is_required": true },
                "prefix": null,
                "suffix": null
              },
              "childs": null
            },
            {
              "key": "2.2",
              "type": {
                "field": "dropdown",
                "editable": true,
                "label": "Female",
                "options": ["YES", "NO"],
                "validator": { "is_required": true },
                "prefix": null,
                "suffix": null
              },
              "childs": null
            }
          ]
        },
        {
          "key": "3",
          "type": {
            "field": "textbox",
            "editable": true,
            "label": "Age",
            "validator": {
              "is_required": true,
              "is_integer": true,
              "min": 18.0,
              "max": 60.0
            },
            "prefix": null,
            "suffix": "Years"
          },
          "childs": null
        },
        {
          "key": "4",
          "type": {
            "field": "datepicker",
            "editable": true,
            "label": "Date Of Birth",
            "validator": {
              "is_required": true,
              "max": 946665000
            },
            "prefix": null,
            "suffix": null
          },
          "childs": null
        },
        {
          "key": "5",
          "type": {
            "field": "void",
            "label": "Document",
            "validator": null,
            "prefix": null,
            "suffix": null
          },
          "childs": [
            {
              "key": "5.1",
              "type": {
                "field": "attachment",
                "editable": true,
                "label": "Photo",
                "validator": {
                  "is_required": false,
                  "multiple": true,
                  "formats": ["png", "jpeg", "jpg"]
                },
                "prefix": null,
                "suffix": null
              },
              "childs": null
            },
            {
              "key": "5.2",
              "type": {
                "field": "attachment",
                "editable": true,
                "label": "Resume",
                "validator": {
                  "is_required": true,
                  "multiple": false,
                  "formats": ["pdf"]
                },
                "prefix": null,
                "suffix": null
              },
              "childs": null
            }
          ]
        }
      ]
    },
    "aggrigator": {
      "keys": ["3"],
      "type": "sum"
    },
    "is_growable": false,
    "name": "Recruitment Data",
    "code": "A19"
  }

]

export const dummyAnnexuresList1 = [
  {
    "header": {
      "content": [
        {
          "key": "1",
          "type": {
            "field": "textbox",
            "editable": true,
            "label": "Candidate Name",
            "validator": {
              "is_required": true,
              "min_len": 3,
              "max_len": 20
            },
            "prefix": null,
            "suffix": null
          },
          "childs": null
        },
        {
          "key": "2",
          "type": {
            "field": "void",
            "label": "Gender",
            "validator": null,
            "prefix": null,
            "suffix": null
          },
          "childs": [
            {
              "key": "2.1",
              "type": {
                "field": "dropdown",
                "editable": true,
                "label": "Male",
                "options": ["YES", "NO"],
                "validator": { "is_required": true, multiple: true},
                "prefix": null,
                "suffix": null
              },
              "childs": null
            },
            {
              "key": "2.2",
              "type": {
                "field": "dropdown",
                "editable": true,
                "label": "Female",
                "options": ["YES", "NO"],
                "validator": { "is_required": true },
                "prefix": null,
                "suffix": null
              },
              "childs": null
            }
          ]
        },
        {
          "key": "3",
          "type": {
            "field": "textbox",
            "editable": true,
            "label": "Age",
            "validator": {
              "is_required": true,
              "is_integer": true,
              "min": 18.0,
              "max": 60.0
            },
            "prefix": null,
            "suffix": "Years"
          },
          "childs": null
        },
        {
          "key": "4",
          "type": {
            "field": "datepicker",
            "editable": true,
            "label": "Date Of Birth",
            "validator": {
              "is_required": true,
              "max": 946665000
            },
            "prefix": null,
            "suffix": null
          },
          "childs": null
        },
        {
          "key": "5",
          "type": {
            "field": "void",
            "label": "Document",
            "validator": null,
            "prefix": null,
            "suffix": null
          },
          "childs": [
            {
              "key": "5.1",
              "type": {
                "field": "attachment",
                "editable": true,
                "label": "Photo",
                "validator": {
                  "is_required": false,
                  "multiple": true,
                  "formats": ["png", "jpeg", "jpg"]
                },
                "prefix": null,
                "suffix": null
              },
              "childs": null
            },
            {
              "key": "5.2",
              "type": {
                "field": "void",
                "label": "Resume",
                "prefix": null,
                "suffix": null
              },
              "childs": [
                {
                  "key": "5.2.1",
                  "type": {
                    "field": "attachment",
                    "editable": true,
                    "label": "preveious",
                    "validator": {
                      "is_required": true,
                      "multiple": false,
                      "formats": ["pdf"]
                    },
                    "prefix": null,
                    "suffix": null
                  },
                  "childs": null
                },
                {
                  "key": "5.2.2",
                  "type": {
                    "field": "attachment",
                    "editable": true,
                    "label": "LAtest",
                    "validator": {
                      "is_required": true,
                      "multiple": false,
                      "formats": ["pdf"]
                    },
                    "prefix": null,
                    "suffix": null
                  },
                  "childs": null
                },
              ]
            }
          ]
        },
        {
          "key": "6",
          "type": {
            "field": "datetimepicker",
            "editable": true,
            "label": "TIMEEEE",
            "validator":null,
            "prefix": null,
            "suffix": null
          },
          "childs": null
        },
      ]
    },
    "aggrigator": {
      "keys": ["3"],
      "type": "sum"
    },
    "is_growable": true,
    "name": "Recruitment Data",
    "code": "A17"
  },
  {
    "header": {
        "content": [
            {
                "key": "1",
                "type": {
                    "field": "textbox",
                    "editable": true,
                    "label": "Division Name"
                },
                "childs": null
            },
            {
                "key": "2",
                "type": {
                    "field": "textbox",
                    "editable": true,
                    "label": "Total Route Kms",
                    "validator": {
                        "is_numeric": true,
                        "min": 0
                    },
                    "prefix": null,
                    "suffix": null
                }
            },
            {
                "key": "3",
                "type": {
                    "field": "textbox",
                    "editable": false,
                    "label": "Route",
                    "validator": null,
                    "prefix": null,
                    "suffix": null
                }
            },
            {
                "key": "4",
                "type": {
                    "field": "textbox",
                    "editable": true,
                    "label": "Route Kms Covered by OFC Only",
                    "validator": {
                        "is_numeric": true,
                        "min": 0
                    },
                    "prefix": null,
                    "suffix": null
                }
            },
            {
                "key": "5",
                "type": {
                    "field": "textbox",
                    "editable": true,
                    "label": "Route Kms Covered by  Quad Only",
                    "validator": {
                        "is_numeric": true,
                        "min": 0
                    },
                    "prefix": null,
                    "suffix": null
                }
            },
            {
                "key": "6",
                "type": {
                    "field": "textbox",
                    "editable": true,
                    "label": "Route Kms Covered by OFC & Quad both",
                    "validator": {
                        "is_numeric": true,
                        "min": 0
                    },
                    "prefix": null,
                    "suffix": null
                }
            },
            {
                "key": "7",
                "type": {
                    "field": "textbox",
                    "editable": true,
                    "label": "Route Kms Covered by O/H Alignment",
                    "validator": {
                        "is_numeric": true,
                        "min": 0
                    },
                    "prefix": null,
                    "suffix": null
                }
            },
            {
                "key": "8",
                "type": {
                    "field": "textbox",
                    "editable": true,
                    "label": "Route Kms Covered by OFC & RE Cable",
                    "validator": {
                        "is_numeric": true,
                        "min": 0
                    },
                    "prefix": null,
                    "suffix": null
                }
            },
            {
                "key": "9",
                "type": {
                    "field": "textbox",
                    "editable": true,
                    "label": "Route Kms Covered by RE Cable Only",
                    "validator": {
                        "is_numeric": true,
                        "min": 0
                    },
                    "prefix": null,
                    "suffix": null
                }
            },
            {
                "key": "10",
                "type": {
                    "field": "textbox",
                    "editable": true,
                    "label": "Route Kms Covered by Others",
                    "validator": {
                        "is_numeric": true,
                        "min": 0
                    },
                    "prefix": null,
                    "suffix": null
                }
            },
            {
                "key": "11",
                "type": {
                    "field": "textbox",
                    "editable": true,
                    "label": "Remarks",
                    "validator": null,
                    "prefix": null,
                    "suffix": null
                }
            }
        ]
    },
    "aggrigator": {
        "keys": [
            "2",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "10"
        ],
        "type": "sum"
    },
    "is_growable": false,
    "name": "Telecommunication Cable Coverage",
    "code": "T5"
},
{
  "header": {
      "content": [
          {
              "key": "1",
              "type": {
                  "field": "void",
                  "editable": false,
                  "label": "Sr. No."
              },
              "childs": [
                  {
                      "key": "1.1",
                      "type": {
                          "field": "textbox",
                          "editable": true,
                          "label": "1",
                          "validator": {
                              "is_numeric": true,
                              "min": 0
                          },
                          "prefix": null,
                          "suffix": null
                      }
                  }
              ]
          },
          {
              "key": "2",
              "type": {
                  "field": "void",
                  "editable": false,
                  "label": "Name of Eqpt.",
                  "validator": null,
                  "prefix": null,
                  "suffix": null
              },
              "childs": [
                  {
                      "key": "2.1",
                      "type": {
                          "field": "textbox",
                          "editable": true,
                          "label": "2",
                          "prefix": null,
                          "suffix": null
                      }
                  }
              ]
          },
          {
              "key": "3",
              "type": {
                  "field": "void",
                  "editable": false,
                  "label": "Make",
                  "validator": null,
                  "prefix": null,
                  "suffix": null
              },
              "childs": [
                  {
                      "key": "3.1",
                      "type": {
                          "field": "textbox",
                          "editable": true,
                          "label": "3",
                          "prefix": null,
                          "suffix": null
                      }
                  }
              ]
          },
          {
              "key": "4",
              "type": {
                  "field": "void",
                  "editable": true,
                  "label": "Total No. of Eqpts (on date)",
                  "validator": null,
                  "prefix": null,
                  "suffix": null
              },
              "childs": [
                  {
                      "key": "4.1",
                      "type": {
                          "field": "textbox",
                          "editable": true,
                          "label": "4",
                          "validator": {
                              "is_numeric": true,
                              "min": 0
                          },
                          "prefix": null,
                          "suffix": null
                      }
                  }
              ]
          },
          {
              "key": "5",
              "type": {
                  "field": "void",
                  "editable": true,
                  "label": "Total Hrs. in use",
                  "validator": null,
                  "prefix": null,
                  "suffix": null
              },
              "childs": [
                  {
                      "key": "5.1",
                      "type": {
                          "field": "textbox",
                          "editable": true,
                          "label": "Cum. Upto Last Month",
                          "validator": {
                              "is_numeric": true,
                              "min": 0
                          },
                          "prefix": null,
                          "suffix": null
                      }
                  },
                  {
                      "key": "5.2",
                      "type": {
                          "field": "void",
                          "editable": false,
                          "label": "Cum. Upto Current Month",
                          "validator": null,
                          "prefix": null,
                          "suffix": null
                      },
                      "childs": [
                          {
                              "key": "5.2.1",
                              "type": {
                                  "field": "textbox",
                                  "editable": true,
                                  "label": "5.A",
                                  "validator": {
                                      "is_numeric": true,
                                      "min": 0
                                  },
                                  "prefix": null,
                                  "suffix": null
                              }
                          }
                      ]
                  },
                  {
                      "key": "5.3",
                      "type": {
                          "field": "textbox",
                          "editable": true,
                          "label": "During the Month",
                          "validator": null,
                          "prefix": null,
                          "suffix": null
                      },
                      "childs": [
                          {
                              "key": "5.3.1",
                              "type": {
                                  "field": "textbox",
                                  "editable": true,
                                  "label": "5.B",
                                  "validator": {
                                      "is_numeric": true,
                                      "min": 0
                                  },
                                  "prefix": null,
                                  "suffix": null
                              }
                          }
                      ]
                  }
              ]
          },
          {
              "key": "6",
              "type": {
                  "field": "void",
                  "editable": true,
                  "label": "Total Nos. of failures",
                  "validator": null,
                  "prefix": null,
                  "suffix": null
              },
              "childs": [
                  {
                      "key": "6.1",
                      "type": {
                          "field": "textbox",
                          "editable": true,
                          "label": "Cum. Upto Last Month",
                          "validator": {
                              "is_numeric": true,
                              "min": 0
                          },
                          "prefix": null,
                          "suffix": null
                      }
                  },
                  {
                      "key": "6.2",
                      "type": {
                          "field": "void",
                          "editable": false,
                          "label": "Cum. Upto Current Month",
                          "validator": null,
                          "prefix": null,
                          "suffix": null
                      },
                      "childs": [
                          {
                              "key": "6.2.1",
                              "type": {
                                  "field": "textbox",
                                  "editable": true,
                                  "label": "6.A",
                                  "validator": {
                                      "is_numeric": true,
                                      "min": 0
                                  },
                                  "prefix": null,
                                  "suffix": null
                              }
                          }
                      ]
                  },
                  {
                      "key": "6.3",
                      "type": {
                          "field": "textbox",
                          "editable": true,
                          "label": "During the Month",
                          "validator": null,
                          "prefix": null,
                          "suffix": null
                      },
                      "childs": [
                          {
                              "key": "6.3.1",
                              "type": {
                                  "field": "textbox",
                                  "editable": true,
                                  "label": "6.B",
                                  "validator": {
                                      "is_numeric": true,
                                      "min": 0
                                  },
                                  "prefix": null,
                                  "suffix": null
                              }
                          }
                      ]
                  }
              ]
          },
          {
              "key": "7",
              "type": {
                  "field": "void",
                  "editable": true,
                  "label": "Total Down time (in hrs)",
                  "validator": null,
                  "prefix": null,
                  "suffix": null
              },
              "childs": [
                  {
                      "key": "7.1",
                      "type": {
                          "field": "textbox",
                          "editable": true,
                          "label": "Cum. Upto Last Month",
                          "validator": {
                              "is_numeric": true,
                              "min": 0
                          },
                          "prefix": null,
                          "suffix": null
                      }
                  },
                  {
                      "key": "7.2",
                      "type": {
                          "field": "void",
                          "editable": false,
                          "label": "Cum. Upto Current Month",
                          "validator": null,
                          "prefix": null,
                          "suffix": null
                      },
                      "childs": [
                          {
                              "key": "7.2.1",
                              "type": {
                                  "field": "textbox",
                                  "editable": true,
                                  "label": "7.A",
                                  "validator": {
                                      "is_numeric": true,
                                      "min": 0
                                  },
                                  "prefix": null,
                                  "suffix": null
                              }
                          }
                      ]
                  },
                  {
                      "key": "7.3",
                      "type": {
                          "field": "textbox",
                          "editable": true,
                          "label": "During the Month",
                          "validator": null,
                          "prefix": null,
                          "suffix": null
                      },
                      "childs": [
                          {
                              "key": "7.3.1",
                              "type": {
                                  "field": "textbox",
                                  "editable": true,
                                  "label": "7.B",
                                  "validator": {
                                      "is_numeric": true,
                                      "min": 0
                                  },
                                  "prefix": null,
                                  "suffix": null
                              }
                          }
                      ]
                  }
              ]
          },
          {
              "key": "8",
              "type": {
                  "field": "void",
                  "editable": true,
                  "label": "MTBF (5/6)",
                  "validator": null,
                  "prefix": null,
                  "suffix": null
              },
              "childs": [
                  {
                      "key": "8.1",
                      "type": {
                          "field": "void",
                          "editable": false,
                          "label": "Cum. Upto Current Month",
                          "validator": null,
                          "prefix": null,
                          "suffix": null
                      },
                      "childs": [
                          {
                              "key": "8.1.1",
                              "type": {
                                  "field": "textbox",
                                  "editable": true,
                                  "label": "8.A",
                                  "validator": {
                                      "is_numeric": true,
                                      "min": 0
                                  },
                                  "prefix": null,
                                  "suffix": null
                              }
                          }
                      ]
                  },
                  {
                      "key": "8.2",
                      "type": {
                          "field": "textbox",
                          "editable": true,
                          "label": "During the Month",
                          "validator": null,
                          "prefix": null,
                          "suffix": null
                      },
                      "childs": [
                          {
                              "key": "8.2.1",
                              "type": {
                                  "field": "textbox",
                                  "editable": true,
                                  "label": "8.B",
                                  "validator": {
                                      "is_numeric": true,
                                      "min": 0
                                  },
                                  "prefix": null,
                                  "suffix": null
                              }
                          }
                      ]
                  }
              ]
          },
          {
              "key": "9",
              "type": {
                  "field": "void",
                  "editable": true,
                  "label": "MTTR (7/6)",
                  "validator": null,
                  "prefix": null,
                  "suffix": null
              },
              "childs": [
                  {
                      "key": "9.1",
                      "type": {
                          "field": "void",
                          "editable": false,
                          "label": "Cum. Upto Current Month",
                          "validator": null,
                          "prefix": null,
                          "suffix": null
                      },
                      "childs": [
                          {
                              "key": "9.1.1",
                              "type": {
                                  "field": "textbox",
                                  "editable": true,
                                  "label": "9.A",
                                  "validator": {
                                      "is_numeric": true,
                                      "min": 0
                                  },
                                  "prefix": null,
                                  "suffix": null
                              }
                          }
                      ]
                  },
                  {
                      "key": "9.2",
                      "type": {
                          "field": "textbox",
                          "editable": true,
                          "label": "During the Month",
                          "validator": null,
                          "prefix": null,
                          "suffix": null
                      },
                      "childs": [
                          {
                              "key": "9.2.1",
                              "type": {
                                  "field": "textbox",
                                  "editable": true,
                                  "label": "9.B",
                                  "validator": {
                                      "is_numeric": true,
                                      "min": 0
                                  },
                                  "prefix": null,
                                  "suffix": null
                              }
                          }
                      ]
                  }
              ]
          },
          {
              "key": "10",
              "type": {
                  "field": "void",
                  "editable": true,
                  "label": "FRPCPY(6A/4) * 12",
                  "validator": null,
                  "prefix": null,
                  "suffix": null
              },
              "childs": [
                  {
                      "key": "10.1",
                      "type": {
                          "field": "void",
                          "editable": false,
                          "label": "Current Month",
                          "validator": null,
                          "prefix": null,
                          "suffix": null
                      },
                      "childs": [
                          {
                              "key": "10.1.1",
                              "type": {
                                  "field": "textbox",
                                  "editable": true,
                                  "label": "10",
                                  "validator": {
                                      "is_numeric": true,
                                      "min": 0
                                  },
                                  "prefix": null,
                                  "suffix": null
                              }
                          }
                      ]
                  }
              ]
          },
          {
              "key": "11",
              "type": {
                  "field": "textbox",
                  "editable": true,
                  "label": "Remarks",
                  "validator": null,
                  "prefix": null,
                  "suffix": null
              }
          }
      ]
  },
  "aggrigator": {
      "keys": [
          "4.1",
          "5.1",
          "5.2.1",
          "5.3.1",
          "6.1",
          "6.2.1",
          "6.3.1",
          "7.1",
          "7.2.1",
          "7.3.1",
          "8.1.1",
          "8.2.1",
          "9.1.1",
          "9.2.1",
          "10.1.1"
      ],
      "type": "sum"
  },
  "is_growable": true,
  "name": "Summary of Failure Rate (FRPCPY) Record for Telecom Equipments",
  "code": "T6"
}

]

export const dummyAnnexuresList2 =[
  {
    key: "1",
    childs: null,
    field: "textbox",
    editable: true,
    label: "Candidate Name",
    validator: {
      is_required: true,
      min_len: 3,
      max_len: 20,
    },
    prefix: null,
    suffix: null,
  },
  {
    key: "2",
    childs: [
      {
        key: "2.1",
        childs: null,
        field: "dropdown",
        editable: true,
        label: "Male",
        options: ["YES", "NO"],
        validator: {
          is_required: true,
        },
        prefix: null,
        suffix: null,
      },
      {
        key: "2.2",
        childs: null,
        field: "dropdown",
        editable: true,
        label: "Female",
        options: ["YES", "NO"],
        validator: {
          is_required: true,
        },
        prefix: null,
        suffix: null,
      },
    ],
    field: "void",
    label: "Gender",
    validator: null,
    prefix: null,
    suffix: null,
  },
  {
    key: "3",
    childs: null,
    field: "textbox",
    editable: true,
    label: "Age",
    validator: {
      is_required: true,
      is_integer: true,
      min: 18,
      max: 60,
    },
    prefix: null,
    suffix: "Years",
  },
  {
    key: "4",
    childs: null,
    field: "datepicker",
    editable: true,
    label: "Date Of Birth",
    validator: {
      is_required: true,
      max: 946665000,
    },
    prefix: null,
    suffix: null,
  },
  {
    key: "5",
    childs: [
      {
        key: "5.1",
        childs: null,
        field: "attachment",
        editable: true,
        label: "Photo",
        validator: {
          is_required: false,
          multiple: true,
          formats: ["png", "jpeg", "jpg"],
        },
        prefix: null,
        suffix: null,
      },
      {
        key: "5.2",
        childs: [
            {
              key: "5.2.1",
              childs: null,
              field: "dropdown",
              editable: true,
              label: "Is varified by you",
              options: ["YES", "NO"],
              validator: {
                is_required: true,
              },
              prefix: null,
              suffix: null,
            },
            {
              key: "5.2.2",
              childs: null,
              field: "dropdown",
              editable: true,
              label: "is varified by teacher",
              options: ["YES", "NO"],
              validator: {
                is_required: true,
              },
              prefix: null,
              suffix: null,
            },
          ],
        field: "attachment",
        editable: true,
        label: "Resume",
        validator: {
          is_required: true,
          multiple: false,
          formats: ["pdf"],
        },
        prefix: null,
        suffix: null,
      },
      {
        key: "5.3",
        childs: null,
        field: "attachment",
        editable: true,
        label: "Birth Certificate",
        validator: {
          is_required: true,
          multiple: false,
          formats: ["pdf"],
        },
        prefix: null,
        suffix: null,
      },
    ],
    field: "void",
    label: "Document",
    validator: null,
    prefix: null,
    suffix: null,
  },
];


export const DUMMY_NEW_TAP_RES = {
  "annexure_instance": {},
  "grid_responses": [
      {
          "id": 0,
          "annexure_instance_id": null,
          "grid_definition_id": 28,
          "rows": [
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      {
                          "key": "1",
                          "val": "OFC"
                      },
                      {
                          "key": "2",
                          "val": null
                      },
                      {
                          "key": "3",
                          "val": null
                      },
                      {
                          "key": "4",
                          "val": null
                      },
                      {
                          "key": "5",
                          "val": null
                      },
                      {
                          "key": "6",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              },
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      {
                          "key": "1",
                          "val": "Quad Cable"
                      },
                      {
                          "key": "3",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              },
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      {
                          "key": "1",
                          "val": "RE Cable (Rly.)"
                      },
                      {
                          "key": "3",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              },
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      {
                          "key": "1",
                          "val": "BSNL O/H"
                      },
                      {
                          "key": "3",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              },
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      {
                          "key": "1",
                          "val": "Railway O/H"
                      },
                      {
                          "key": "3",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              }
          ]
      },
      {
          "id": 0,
          "annexure_instance_id": null,
          "grid_definition_id": 33,
          "rows": [
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      {
                          "key": "1",
                          "val": "OFC"
                      },
                      {
                          "key": "2",
                          "val": null
                      },
                      {
                          "key": "3",
                          "val": null
                      },
                      {
                          "key": "4",
                          "val": null
                      },
                      {
                          "key": "5",
                          "val": null
                      },
                      null
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              },
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      {
                          "key": "1",
                          "val": "Quad Cable"
                      },
                      {
                          "key": "3",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              },
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      {
                          "key": "1",
                          "val": "RE Cable (Rly.)"
                      },
                      {
                          "key": "3",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              },
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      {
                          "key": "1",
                          "val": "BSNL O/H"
                      },
                      {
                          "key": "3",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              },
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      {
                          "key": "1",
                          "val": "Railway O/H"
                      },
                      {
                          "key": "3",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              }
          ]
      },
      {
          "id": 0,
          "annexure_instance_id": null,
          "grid_definition_id": 36,
          "rows": [
              {
                  "id": 1339,
                  "grid_response_id": 299,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "OFC"
                      },
                      {
                          "key": "2",
                          "val": "3951.67"
                      },
                      {
                          "key": "3",
                          "val": "99.98"
                      },
                      {
                          "key": "4",
                          "val": "99.998"
                      },
                      {
                          "key": "5",
                          "val": "100.02"
                      },
                      {
                          "key": "6",
                          "val": "99.996"
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T13:37:48.076175Z"
              },
              {
                  "id": 1340,
                  "grid_response_id": 299,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Quad Cable"
                      },
                      {
                          "key": "3",
                          "val": "99.98"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 1341,
                  "grid_response_id": 299,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "RE Cable (Rly.)"
                      },
                      {
                          "key": "3",
                          "val": "99.98"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 1342,
                  "grid_response_id": 299,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "BSNL O/H"
                      },
                      {
                          "key": "3",
                          "val": "98"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 1343,
                  "grid_response_id": 299,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Railway O/H"
                      },
                      {
                          "key": "3",
                          "val": "98"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 1344,
                  "grid_response_id": 300,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "A"
                      },
                      {
                          "key": "2",
                          "val": 349
                      },
                      {
                          "key": "3",
                          "val": 347
                      },
                      {
                          "key": "4",
                          "val": "99"
                      },
                      {
                          "key": "5",
                          "val": "99.43"
                      },
                      {
                          "key": "6",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:25:32.426141Z"
              },
              {
                  "id": 1345,
                  "grid_response_id": 300,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "B"
                      },
                      {
                          "key": "2",
                          "val": 124
                      },
                      {
                          "key": "3",
                          "val": 123
                      },
                      {
                          "key": "4",
                          "val": "98"
                      },
                      {
                          "key": "5",
                          "val": "99.19"
                      },
                      {
                          "key": "6",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:25:46.751698Z"
              },
              {
                  "id": 1346,
                  "grid_response_id": 300,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "C"
                      },
                      {
                          "key": "2",
                          "val": 49
                      },
                      {
                          "key": "3",
                          "val": 49
                      },
                      {
                          "key": "4",
                          "val": "98"
                      },
                      {
                          "key": "5",
                          "val": "100"
                      },
                      {
                          "key": "6",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:26:02.019311Z"
              },
              {
                  "id": 1347,
                  "grid_response_id": 300,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Dspl"
                      },
                      {
                          "key": "2",
                          "val": 22
                      },
                      {
                          "key": "3",
                          "val": 22
                      },
                      {
                          "key": "4",
                          "val": "95"
                      },
                      {
                          "key": "5",
                          "val": "100"
                      },
                      {
                          "key": "6",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:26:13.345623Z"
              },
              {
                  "id": 1348,
                  "grid_response_id": 300,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "D"
                      },
                      {
                          "key": "2",
                          "val": 67
                      },
                      {
                          "key": "3",
                          "val": 66
                      },
                      {
                          "key": "4",
                          "val": "95"
                      },
                      {
                          "key": "5",
                          "val": "98.51"
                      },
                      {
                          "key": "6",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:26:34.842098Z"
              },
              {
                  "id": 1349,
                  "grid_response_id": 300,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "E"
                      },
                      {
                          "key": "2",
                          "val": 71
                      },
                      {
                          "key": "3",
                          "val": 71
                      },
                      {
                          "key": "4",
                          "val": "95"
                      },
                      {
                          "key": "5",
                          "val": "100"
                      },
                      {
                          "key": "6",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:26:58.992352Z"
              },
              {
                  "id": 1350,
                  "grid_response_id": 301,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Railnet"
                      },
                      {
                          "key": "2",
                          "val": 1049
                      },
                      {
                          "key": "3",
                          "val": 1049
                      },
                      {
                          "key": "4",
                          "val": 0
                      },
                      {
                          "key": "5",
                          "val": 0
                      },
                      {
                          "key": "6",
                          "val": 4
                      },
                      {
                          "key": "7",
                          "val": 100
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:28:05.719639Z"
              },
              {
                  "id": 1351,
                  "grid_response_id": 301,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "UTS/PRS"
                      },
                      {
                          "key": "2",
                          "val": 441
                      },
                      {
                          "key": "3",
                          "val": 439
                      },
                      {
                          "key": "4",
                          "val": 2
                      },
                      {
                          "key": "5",
                          "val": 0
                      },
                      {
                          "key": "6",
                          "val": 3
                      },
                      {
                          "key": "7",
                          "val": 100
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:28:39.431304Z"
              },
              {
                  "id": 1352,
                  "grid_response_id": 301,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "FOIS"
                      },
                      {
                          "key": "2",
                          "val": 143
                      },
                      {
                          "key": "3",
                          "val": 143
                      },
                      {
                          "key": "4",
                          "val": 0
                      },
                      {
                          "key": "5",
                          "val": 0
                      },
                      {
                          "key": "6",
                          "val": 9
                      },
                      {
                          "key": "7",
                          "val": 100
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:29:08.541733Z"
              },
              {
                  "id": 1353,
                  "grid_response_id": 301,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Exchnage"
                      },
                      {
                          "key": "2",
                          "val": 198
                      },
                      {
                          "key": "3",
                          "val": 198
                      },
                      {
                          "key": "4",
                          "val": 0
                      },
                      {
                          "key": "5",
                          "val": 0
                      },
                      {
                          "key": "6",
                          "val": 6
                      },
                      {
                          "key": "7",
                          "val": 100
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:29:49.608718Z"
              },
              {
                  "id": 1354,
                  "grid_response_id": 302,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Railnet"
                      },
                      {
                          "key": "2",
                          "val": 188
                      },
                      {
                          "key": "3",
                          "val": 205
                      },
                      {
                          "key": "4",
                          "val": 205
                      },
                      {
                          "key": "5",
                          "val": 99.9
                      },
                      {
                          "key": "6",
                          "val": 100
                      },
                      {
                          "key": "7",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:31:16.866336Z"
              },
              {
                  "id": 1355,
                  "grid_response_id": 302,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "UTS & PRS"
                      },
                      {
                          "key": "2",
                          "val": 508
                      },
                      {
                          "key": "3",
                          "val": 576
                      },
                      {
                          "key": "4",
                          "val": 573
                      },
                      {
                          "key": "5",
                          "val": 98
                      },
                      {
                          "key": "6",
                          "val": 99.48
                      },
                      {
                          "key": "7",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:31:50.653931Z"
              },
              {
                  "id": 1356,
                  "grid_response_id": 302,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "FOIS"
                      },
                      {
                          "key": "2",
                          "val": 289
                      },
                      {
                          "key": "3",
                          "val": 258
                      },
                      {
                          "key": "4",
                          "val": 257
                      },
                      {
                          "key": "5",
                          "val": 98
                      },
                      {
                          "key": "6",
                          "val": 99.61
                      },
                      {
                          "key": "7",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:32:31.996699Z"
              },
              {
                  "id": 1357,
                  "grid_response_id": 302,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Exchnage"
                      },
                      {
                          "key": "2",
                          "val": 152
                      },
                      {
                          "key": "3",
                          "val": 213
                      },
                      {
                          "key": "4",
                          "val": 213
                      },
                      {
                          "key": "5",
                          "val": 98
                      },
                      {
                          "key": "6",
                          "val": 100
                      },
                      {
                          "key": "7",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:33:02.557689Z"
              },
              {
                  "id": 1358,
                  "grid_response_id": 303,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "FOIS"
                      },
                      {
                          "key": "2",
                          "val": 192
                      },
                      {
                          "key": "3",
                          "val": 191
                      },
                      {
                          "key": "4",
                          "val": 98
                      },
                      {
                          "key": "5",
                          "val": 99.48
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:33:46.02072Z"
              },
              {
                  "id": 1359,
                  "grid_response_id": 303,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "UTS/PRS"
                      },
                      {
                          "key": "2",
                          "val": 480
                      },
                      {
                          "key": "3",
                          "val": 477
                      },
                      {
                          "key": "4",
                          "val": 99
                      },
                      {
                          "key": "5",
                          "val": 99.38
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:34:10.665744Z"
              },
              {
                  "id": 1360,
                  "grid_response_id": 304,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "OFC"
                      },
                      {
                          "key": "2",
                          "val": 8
                      },
                      {
                          "key": "3",
                          "val": 3951.19
                      },
                      {
                          "key": "4",
                          "val": "<6 Hrs."
                      },
                      {
                          "key": "5",
                          "val": "7:08:00"
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:34:47.439354Z"
              },
              {
                  "id": 1361,
                  "grid_response_id": 304,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Quad"
                      },
                      {
                          "key": "2",
                          "val": 6
                      },
                      {
                          "key": "3",
                          "val": 4030.07
                      },
                      {
                          "key": "4",
                          "val": "<5 Hrs."
                      },
                      {
                          "key": "5",
                          "val": "4:02:00"
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:35:12.592421Z"
              },
              {
                  "id": 1362,
                  "grid_response_id": 305,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Block Ckt. Failure"
                      },
                      {
                          "key": "2",
                          "val": 344
                      },
                      {
                          "key": "3",
                          "val": 9
                      },
                      {
                          "key": "4",
                          "val": "<5 Hrs."
                      },
                      {
                          "key": "5",
                          "val": "3:18:00"
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:35:33.156841Z"
              },
              {
                  "id": 1363,
                  "grid_response_id": 305,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Data Logger Network Failure"
                      },
                      {
                          "key": "2",
                          "val": 466
                      },
                      {
                          "key": "3",
                          "val": 3
                      },
                      {
                          "key": "4",
                          "val": "<5 Hrs."
                      },
                      {
                          "key": "5",
                          "val": "4:12:00"
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:35:44.779092Z"
              },
              {
                  "id": 1364,
                  "grid_response_id": 306,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "FOIS"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 1365,
                  "grid_response_id": 306,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "UTS & PRS"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 1366,
                  "grid_response_id": 307,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Provision of IP-MPLS (No. of Stns)"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 1367,
                  "grid_response_id": 307,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Provision of IP Exchange "
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 1368,
                  "grid_response_id": 307,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Provision of No. of Stations to be provided with VoIP Control Communications"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 1369,
                  "grid_response_id": 307,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Provision of Lightening/Surge Protection (as per RDSO guideline for Telecom gears) *"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 1370,
                  "grid_response_id": 307,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Provision of  Earthing at Telecom Installations *"
                      },
                      {
                          "key": "2",
                          "val": 30
                      },
                      {
                          "key": "3",
                          "val": 2
                      },
                      {
                          "key": "4",
                          "val": 5
                      },
                      {
                          "key": "5",
                          "val": "SUR: 02 locations"
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:36:56.479297Z"
              },
              {
                  "id": 1371,
                  "grid_response_id": 307,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Provision of  Fire Alarm & Detection System *"
                      },
                      {
                          "key": "2",
                          "val": 101
                      },
                      {
                          "key": "3",
                          "val": 23
                      },
                      {
                          "key": "4",
                          "val": 103
                      },
                      {
                          "key": "5",
                          "val": "SUR:23 locations"
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:37:22.417315Z"
              },
              {
                  "id": 1372,
                  "grid_response_id": 307,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Provision of  Meggering of Quad Cable*"
                      },
                      {
                          "key": "2",
                          "val": 174
                      },
                      {
                          "key": "3",
                          "val": 23
                      },
                      {
                          "key": "4",
                          "val": 137
                      },
                      {
                          "key": "5",
                          "val": "NGP: 23 sections."
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:37:43.065139Z"
              },
              {
                  "id": 1373,
                  "grid_response_id": 307,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Provision of  Monitoring of CCTV equip at all stations through NMS/Dashboard*"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 1374,
                  "grid_response_id": 307,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Replacement of Old batteries Provided for PDMUX/STM-1/OFC Equipment *"
                      },
                      {
                          "key": "2",
                          "val": 70
                      },
                      {
                          "key": "3",
                          "val": null
                      },
                      {
                          "key": "4",
                          "val": 47
                      },
                      {
                          "key": "5",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:38:11.022876Z"
              },
              {
                  "id": 1375,
                  "grid_response_id": 307,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Replacement of Old batteries Provided for Exchanges *"
                      },
                      {
                          "key": "2",
                          "val": 1
                      },
                      {
                          "key": "3",
                          "val": null
                      },
                      {
                          "key": "4",
                          "val": 1
                      },
                      {
                          "key": "5",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:38:26.451989Z"
              },
              {
                  "id": 1376,
                  "grid_response_id": 307,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Replacement of Old batteries Provided for Walkie - Talkie (5W) *"
                      },
                      {
                          "key": "2",
                          "val": 2200
                      },
                      {
                          "key": "3",
                          "val": 124
                      },
                      {
                          "key": "4",
                          "val": 2995
                      },
                      {
                          "key": "5",
                          "val": "BB-105,NGP - 8,PA - 11"
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:39:05.024271Z"
              },
              {
                  "id": 1377,
                  "grid_response_id": 307,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Replacement of Old batteries Provided for VHF (25W) Sets. *"
                      },
                      {
                          "key": "2",
                          "val": 222
                      },
                      {
                          "key": "3",
                          "val": 9
                      },
                      {
                          "key": "4",
                          "val": 42
                      },
                      {
                          "key": "5",
                          "val": "BB: 05 Batteries,NGP : 04 Batteries."
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:39:44.964907Z"
              },
              {
                  "id": 1378,
                  "grid_response_id": 307,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Replacement of Old batteries Provided for Datacom Equipment's *"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 1379,
                  "grid_response_id": 307,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Replacement of Old batteries Provided for BTS (MTRC) *"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 1380,
                  "grid_response_id": 307,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Replacement of Old batteries Provided for IPIS *"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 1381,
                  "grid_response_id": 307,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Replacement of Old batteries Provided for CCTV *"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 1382,
                  "grid_response_id": 307,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Surrender/ Condemnation/replacement for VHF Sets *"
                      },
                      {
                          "key": "2",
                          "val": 250
                      },
                      {
                          "key": "3",
                          "val": 0
                      },
                      {
                          "key": "4",
                          "val": 504
                      },
                      {
                          "key": "5",
                          "val": "BB- 293 sets Condemned.,BSL-211 Sets Condemned."
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:40:32.208709Z"
              },
              {
                  "id": 1383,
                  "grid_response_id": 307,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Surrender/ Condemnation/replacement for V-SATs *"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 1384,
                  "grid_response_id": 307,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Rail Madad complaints redressal (Time Taken) Average complaints redressal time "
                      },
                      {
                          "key": "2",
                          "val": 120
                      },
                      {
                          "key": "3",
                          "val": ""
                      },
                      {
                          "key": "4",
                          "val": null
                      },
                      {
                          "key": "5",
                          "val": "42 complaints disposed."
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:42:56.525015Z"
              },
              {
                  "id": 1933,
                  "grid_response_id": 308,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Payment to RCIL (HQ)"
                      },
                      {
                          "key": "2",
                          "val": "0"
                      },
                      {
                          "key": "3",
                          "val": null
                      },
                      {
                          "key": "4",
                          "val": null
                      },
                      {
                          "key": "5",
                          "val": 35374
                      },
                      {
                          "key": "6",
                          "val": 100
                      }
                  ],
                  "created_by": 3,
                  "updated_by": 3,
                  "created_dt": "2024-05-11T12:44:03.132224Z",
                  "updated_dt": "2024-05-11T12:45:14.480642Z"
              },
              {
                  "id": 1934,
                  "grid_response_id": 308,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Payment to RCIL (DIV)"
                      },
                      {
                          "key": "2",
                          "val": null
                      },
                      {
                          "key": "3",
                          "val": null
                      },
                      {
                          "key": "4",
                          "val": 2347
                      },
                      {
                          "key": "5",
                          "val": 5098
                      },
                      {
                          "key": "6",
                          "val": 100
                      }
                  ],
                  "created_by": 3,
                  "updated_by": 3,
                  "created_dt": "2024-05-11T12:45:02.347512Z",
                  "updated_dt": "2024-05-11T12:45:02.347512Z"
              },
              {
                  "id": 1385,
                  "grid_response_id": 309,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "PH-33"
                      },
                      {
                          "key": "2",
                          "val": 101609
                      },
                      {
                          "key": "3",
                          "val": 332011
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:45:37.157329Z"
              },
              {
                  "id": 1386,
                  "grid_response_id": 309,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "PH-64"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 1387,
                  "grid_response_id": 309,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "PH-29"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 1388,
                  "grid_response_id": 309,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "PH-53"
                      },
                      {
                          "key": "2",
                          "val": 52300
                      },
                      {
                          "key": "3",
                          "val": 38236
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:45:49.217617Z"
              },
              {
                  "id": 1935,
                  "grid_response_id": 310,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Mumbai"
                      },
                      {
                          "key": "2",
                          "val": ""
                      },
                      {
                          "key": "3",
                          "val": "CSTM - Kurla (ML)"
                      },
                      {
                          "key": "4",
                          "val": [
                              "Yes"
                          ]
                      },
                      {
                          "key": "5",
                          "val": null
                      },
                      {
                          "key": "6",
                          "val": 100
                      }
                  ],
                  "created_by": 3,
                  "updated_by": 3,
                  "created_dt": "2024-05-11T12:46:42.449711Z",
                  "updated_dt": "2024-05-11T12:46:42.449711Z"
              },
              {
                  "id": 59496,
                  "grid_response_id": 310,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Mumbai"
                      },
                      {
                          "key": "2",
                          "val": ""
                      },
                      {
                          "key": "3",
                          "val": "Kurla - Kalyan"
                      },
                      {
                          "key": "4",
                          "val": [
                              "Yes"
                          ]
                      },
                      {
                          "key": "5",
                          "val": 0
                      },
                      {
                          "key": "6",
                          "val": 100
                      }
                  ],
                  "created_by": 104,
                  "updated_by": 104,
                  "created_dt": "2024-05-13T07:02:29.935146Z",
                  "updated_dt": "2024-05-13T07:02:29.935146Z"
              },
              {
                  "id": 59497,
                  "grid_response_id": 310,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Mumbai"
                      },
                      {
                          "key": "2",
                          "val": ""
                      },
                      {
                          "key": "3",
                          "val": "Kalyan - Igatpuri (NE)"
                      },
                      {
                          "key": "4",
                          "val": [
                              "Yes"
                          ]
                      },
                      {
                          "key": "5",
                          "val": 0
                      },
                      {
                          "key": "6",
                          "val": 100
                      }
                  ],
                  "created_by": 104,
                  "updated_by": 104,
                  "created_dt": "2024-05-13T07:02:56.479378Z",
                  "updated_dt": "2024-05-13T09:33:11.272853Z"
              },
              {
                  "id": 59498,
                  "grid_response_id": 310,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Mumbai"
                      },
                      {
                          "key": "2",
                          "val": ""
                      },
                      {
                          "key": "3",
                          "val": "Kalyan - Lonavala, Karjat-Khopoli (SE)"
                      },
                      {
                          "key": "4",
                          "val": [
                              "Yes"
                          ]
                      },
                      {
                          "key": "5",
                          "val": 0
                      },
                      {
                          "key": "6",
                          "val": 100
                      }
                  ],
                  "created_by": 104,
                  "updated_by": 104,
                  "created_dt": "2024-05-13T07:03:22.221432Z",
                  "updated_dt": "2024-05-13T09:33:19.360087Z"
              },
              {
                  "id": 59499,
                  "grid_response_id": 310,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Mumbai"
                      },
                      {
                          "key": "2",
                          "val": null
                      },
                      {
                          "key": "3",
                          "val": "CSTM-Bandra (W.Rly), CSTM-Panvel and Thane-Vashi (HB)"
                      },
                      {
                          "key": "4",
                          "val": [
                              "Yes"
                          ]
                      },
                      {
                          "key": "5",
                          "val": 0
                      },
                      {
                          "key": "6",
                          "val": 100
                      }
                  ],
                  "created_by": 104,
                  "updated_by": 104,
                  "created_dt": "2024-05-13T07:04:10.724094Z",
                  "updated_dt": "2024-05-13T07:04:10.724094Z"
              },
              {
                  "id": 59500,
                  "grid_response_id": 310,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Mumbai"
                      },
                      {
                          "key": "2",
                          "val": ""
                      },
                      {
                          "key": "3",
                          "val": "Diva-Vasai Road-Panvel-Jasai (DBRP TFC-1)"
                      },
                      {
                          "key": "4",
                          "val": [
                              "Yes"
                          ]
                      },
                      {
                          "key": "5",
                          "val": 0
                      },
                      {
                          "key": "6",
                          "val": 100
                      }
                  ],
                  "created_by": 104,
                  "updated_by": 104,
                  "created_dt": "2024-05-13T07:19:40.987548Z",
                  "updated_dt": "2024-05-13T07:19:40.987548Z"
              },
              {
                  "id": 36499,
                  "grid_response_id": 7480,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "OFC"
                      },
                      {
                          "key": "3",
                          "val": "99.98"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36500,
                  "grid_response_id": 7480,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Quad Cable"
                      },
                      {
                          "key": "3",
                          "val": "99.98"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36501,
                  "grid_response_id": 7480,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "RE Cable (Rly.)"
                      },
                      {
                          "key": "3",
                          "val": "99.98"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36502,
                  "grid_response_id": 7480,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "BSNL O/H"
                      },
                      {
                          "key": "3",
                          "val": "98"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36503,
                  "grid_response_id": 7480,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Railway O/H"
                      },
                      {
                          "key": "3",
                          "val": "98"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36504,
                  "grid_response_id": 7481,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "A"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36505,
                  "grid_response_id": 7481,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "B"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36506,
                  "grid_response_id": 7481,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "C"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36507,
                  "grid_response_id": 7481,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Dspl"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36508,
                  "grid_response_id": 7481,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "D"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36509,
                  "grid_response_id": 7481,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "E"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36510,
                  "grid_response_id": 7482,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Railnet"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36511,
                  "grid_response_id": 7482,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "UTS/PRS"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36512,
                  "grid_response_id": 7482,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "FOIS"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36513,
                  "grid_response_id": 7482,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Exchnage"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36514,
                  "grid_response_id": 7483,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Railnet"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36515,
                  "grid_response_id": 7483,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "UTS & PRS"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36516,
                  "grid_response_id": 7483,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "FOIS"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36517,
                  "grid_response_id": 7483,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Exchnage"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36518,
                  "grid_response_id": 7484,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "FOIS"
                      },
                      {
                          "key": "4",
                          "val": "98.00"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36519,
                  "grid_response_id": 7484,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "UTS/PRS"
                      },
                      {
                          "key": "4",
                          "val": "99.00"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36520,
                  "grid_response_id": 7485,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "OFC"
                      },
                      {
                          "key": "4",
                          "val": "<6 Hrs."
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36521,
                  "grid_response_id": 7485,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Quad"
                      },
                      {
                          "key": "4",
                          "val": "<5 Hrs."
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36522,
                  "grid_response_id": 7486,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Block Ckt. Failure"
                      },
                      {
                          "key": "4",
                          "val": "<5 Hrs."
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36523,
                  "grid_response_id": 7486,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Data Logger Network Failure"
                      },
                      {
                          "key": "4",
                          "val": "<5 Hrs."
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36524,
                  "grid_response_id": 7487,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "FOIS"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36525,
                  "grid_response_id": 7487,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "UTS & PRS"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36526,
                  "grid_response_id": 7488,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Provision of IP-MPLS (No. of Stns)"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36527,
                  "grid_response_id": 7488,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Provision of IP Exchange "
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36528,
                  "grid_response_id": 7488,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Provision of No. of Stations to be provided with VoIP Control Communications"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36529,
                  "grid_response_id": 7488,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Provision of Lightening/Surge Protection (as per RDSO guideline for Telecom gears) *"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36530,
                  "grid_response_id": 7488,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Provision of  Earthing at Telecom Installations *"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36531,
                  "grid_response_id": 7488,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Provision of  Fire Alarm & Detection System *"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36532,
                  "grid_response_id": 7488,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Provision of  Meggering of Quad Cable*"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36533,
                  "grid_response_id": 7488,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Provision of  Monitoring of CCTV equip at all stations through NMS/Dashboard*"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36534,
                  "grid_response_id": 7488,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Replacement of Old batteries Provided for PDMUX/STM-1/OFC Equipment *"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36535,
                  "grid_response_id": 7488,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Replacement of Old batteries Provided for Exchanges *"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36536,
                  "grid_response_id": 7488,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Replacement of Old batteries Provided for Walkie - Talkie (5W) *"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36537,
                  "grid_response_id": 7488,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Replacement of Old batteries Provided for VHF (25W) Sets. *"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36538,
                  "grid_response_id": 7488,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Replacement of Old batteries Provided for Datacom Equipment's *"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36539,
                  "grid_response_id": 7488,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Replacement of Old batteries Provided for BTS (MTRC) *"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36540,
                  "grid_response_id": 7488,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Replacement of Old batteries Provided for IPIS *"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36541,
                  "grid_response_id": 7488,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Replacement of Old batteries Provided for CCTV *"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36542,
                  "grid_response_id": 7488,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Surrender/ Condemnation/replacement for VHF Sets *"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36543,
                  "grid_response_id": 7488,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Surrender/ Condemnation/replacement for V-SATs *"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36544,
                  "grid_response_id": 7488,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Rail Madad complaints redressal (Time Taken) Average complaints redressal time "
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36545,
                  "grid_response_id": 7490,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "PH-33"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36546,
                  "grid_response_id": 7490,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "PH-64"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36547,
                  "grid_response_id": 7490,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "PH-29"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36548,
                  "grid_response_id": 7490,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "PH-53"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              }
          ]
      },
      {
          "id": 0,
          "annexure_instance_id": null,
          "grid_definition_id": 25,
          "rows": [
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      null,
                      null,
                      {
                          "key": "1",
                          "val": "OFC"
                      },
                      {
                          "key": "2",
                          "val": null
                      },
                      {
                          "key": "3",
                          "val": "99.98"
                      },
                      {
                          "key": "4",
                          "val": null
                      },
                      {
                          "key": "5",
                          "val": null
                      },
                      {
                          "key": "6",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              },
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      null,
                      null,
                      {
                          "key": "1",
                          "val": "Quad Cable"
                      },
                      {
                          "key": "3",
                          "val": "99.98"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              },
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      null,
                      null,
                      {
                          "key": "1",
                          "val": "RE Cable (Rly.)"
                      },
                      {
                          "key": "3",
                          "val": "99.98"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              },
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      null,
                      null,
                      {
                          "key": "1",
                          "val": "BSNL O/H"
                      },
                      {
                          "key": "3",
                          "val": "98"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              },
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      null,
                      null,
                      {
                          "key": "1",
                          "val": "Railway O/H"
                      },
                      {
                          "key": "3",
                          "val": "98"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              }
          ]
      },
      {
          "id": 0,
          "annexure_instance_id": null,
          "grid_definition_id": 26,
          "rows": [
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      null,
                      null,
                      {
                          "key": "1",
                          "val": "OFC"
                      },
                      {
                          "key": "2",
                          "val": null
                      },
                      {
                          "key": "3",
                          "val": null
                      },
                      {
                          "key": "4",
                          "val": null
                      },
                      {
                          "key": "5",
                          "val": null
                      },
                      {
                          "key": "6",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              },
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      null,
                      null,
                      {
                          "key": "1",
                          "val": "Quad Cable"
                      },
                      {
                          "key": "3",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              },
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      null,
                      null,
                      {
                          "key": "1",
                          "val": "RE Cable (Rly.)"
                      },
                      {
                          "key": "3",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              },
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      null,
                      null,
                      {
                          "key": "1",
                          "val": "BSNL O/H"
                      },
                      {
                          "key": "3",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              },
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      null,
                      null,
                      {
                          "key": "1",
                          "val": "Railway O/H"
                      },
                      {
                          "key": "3",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              }
          ]
      },
      {
          "id": 0,
          "annexure_instance_id": null,
          "grid_definition_id": 29,
          "rows": [
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      null,
                      null,
                      {
                          "key": "1",
                          "val": "OFC"
                      },
                      {
                          "key": "2",
                          "val": null
                      },
                      {
                          "key": "3",
                          "val": null
                      },
                      {
                          "key": "4",
                          "val": "99.998"
                      },
                      {
                          "key": "5",
                          "val": null
                      },
                      null
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              },
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      null,
                      null,
                      {
                          "key": "1",
                          "val": "Quad Cable"
                      },
                      {
                          "key": "3",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              },
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      null,
                      null,
                      {
                          "key": "1",
                          "val": "RE Cable (Rly.)"
                      },
                      {
                          "key": "3",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              },
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      null,
                      null,
                      {
                          "key": "1",
                          "val": "BSNL O/H"
                      },
                      {
                          "key": "3",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              },
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      null,
                      null,
                      {
                          "key": "1",
                          "val": "Railway O/H"
                      },
                      {
                          "key": "3",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              }
          ]
      },
      {
          "id": 0,
          "annexure_instance_id": null,
          "grid_definition_id": 31,
          "rows": [
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      {
                          "key": "1",
                          "val": "OFC"
                      },
                      {
                          "key": "2",
                          "val": null
                      },
                      {
                          "key": "3",
                          "val": null
                      },
                      {
                          "key": "4",
                          "val": "99.998"
                      },
                      {
                          "key": "5",
                          "val": null
                      },
                      null
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              },
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      {
                          "key": "1",
                          "val": "Quad Cable"
                      },
                      {
                          "key": "3",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              },
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      {
                          "key": "1",
                          "val": "RE Cable (Rly.)"
                      },
                      {
                          "key": "3",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              },
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      {
                          "key": "1",
                          "val": "BSNL O/H"
                      },
                      {
                          "key": "3",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              },
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      {
                          "key": "1",
                          "val": "Railway O/H"
                      },
                      {
                          "key": "3",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              }
          ]
      },
      {
          "id": 0,
          "annexure_instance_id": null,
          "grid_definition_id": 34,
          "rows": [
              {
                  "id": 1339,
                  "grid_response_id": 299,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "OFC"
                      },
                      {
                          "key": "2",
                          "val": "3951.67"
                      },
                      {
                          "key": "3",
                          "val": "99.98"
                      },
                      {
                          "key": "4",
                          "val": "99.998"
                      },
                      {
                          "key": "5",
                          "val": "100.02"
                      },
                      {
                          "key": "6",
                          "val": "99.996"
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T13:37:48.076175Z"
              },
              {
                  "id": 1340,
                  "grid_response_id": 299,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Quad Cable"
                      },
                      {
                          "key": "3",
                          "val": "99.98"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 1341,
                  "grid_response_id": 299,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "RE Cable (Rly.)"
                      },
                      {
                          "key": "3",
                          "val": "99.98"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 1342,
                  "grid_response_id": 299,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "BSNL O/H"
                      },
                      {
                          "key": "3",
                          "val": "98"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 1343,
                  "grid_response_id": 299,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Railway O/H"
                      },
                      {
                          "key": "3",
                          "val": "98"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 1344,
                  "grid_response_id": 300,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "A"
                      },
                      {
                          "key": "2",
                          "val": 349
                      },
                      {
                          "key": "3",
                          "val": 347
                      },
                      {
                          "key": "4",
                          "val": "99"
                      },
                      {
                          "key": "5",
                          "val": "99.43"
                      },
                      {
                          "key": "6",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:25:32.426141Z"
              },
              {
                  "id": 1345,
                  "grid_response_id": 300,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "B"
                      },
                      {
                          "key": "2",
                          "val": 124
                      },
                      {
                          "key": "3",
                          "val": 123
                      },
                      {
                          "key": "4",
                          "val": "98"
                      },
                      {
                          "key": "5",
                          "val": "99.19"
                      },
                      {
                          "key": "6",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:25:46.751698Z"
              },
              {
                  "id": 1346,
                  "grid_response_id": 300,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "C"
                      },
                      {
                          "key": "2",
                          "val": 49
                      },
                      {
                          "key": "3",
                          "val": 49
                      },
                      {
                          "key": "4",
                          "val": "98"
                      },
                      {
                          "key": "5",
                          "val": "100"
                      },
                      {
                          "key": "6",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:26:02.019311Z"
              },
              {
                  "id": 1347,
                  "grid_response_id": 300,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Dspl"
                      },
                      {
                          "key": "2",
                          "val": 22
                      },
                      {
                          "key": "3",
                          "val": 22
                      },
                      {
                          "key": "4",
                          "val": "95"
                      },
                      {
                          "key": "5",
                          "val": "100"
                      },
                      {
                          "key": "6",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:26:13.345623Z"
              },
              {
                  "id": 1348,
                  "grid_response_id": 300,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "D"
                      },
                      {
                          "key": "2",
                          "val": 67
                      },
                      {
                          "key": "3",
                          "val": 66
                      },
                      {
                          "key": "4",
                          "val": "95"
                      },
                      {
                          "key": "5",
                          "val": "98.51"
                      },
                      {
                          "key": "6",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:26:34.842098Z"
              },
              {
                  "id": 1349,
                  "grid_response_id": 300,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "E"
                      },
                      {
                          "key": "2",
                          "val": 71
                      },
                      {
                          "key": "3",
                          "val": 71
                      },
                      {
                          "key": "4",
                          "val": "95"
                      },
                      {
                          "key": "5",
                          "val": "100"
                      },
                      {
                          "key": "6",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:26:58.992352Z"
              },
              {
                  "id": 1350,
                  "grid_response_id": 301,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Railnet"
                      },
                      {
                          "key": "2",
                          "val": 1049
                      },
                      {
                          "key": "3",
                          "val": 1049
                      },
                      {
                          "key": "4",
                          "val": 0
                      },
                      {
                          "key": "5",
                          "val": 0
                      },
                      {
                          "key": "6",
                          "val": 4
                      },
                      {
                          "key": "7",
                          "val": 100
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:28:05.719639Z"
              },
              {
                  "id": 1351,
                  "grid_response_id": 301,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "UTS/PRS"
                      },
                      {
                          "key": "2",
                          "val": 441
                      },
                      {
                          "key": "3",
                          "val": 439
                      },
                      {
                          "key": "4",
                          "val": 2
                      },
                      {
                          "key": "5",
                          "val": 0
                      },
                      {
                          "key": "6",
                          "val": 3
                      },
                      {
                          "key": "7",
                          "val": 100
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:28:39.431304Z"
              },
              {
                  "id": 1352,
                  "grid_response_id": 301,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "FOIS"
                      },
                      {
                          "key": "2",
                          "val": 143
                      },
                      {
                          "key": "3",
                          "val": 143
                      },
                      {
                          "key": "4",
                          "val": 0
                      },
                      {
                          "key": "5",
                          "val": 0
                      },
                      {
                          "key": "6",
                          "val": 9
                      },
                      {
                          "key": "7",
                          "val": 100
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:29:08.541733Z"
              },
              {
                  "id": 1353,
                  "grid_response_id": 301,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Exchnage"
                      },
                      {
                          "key": "2",
                          "val": 198
                      },
                      {
                          "key": "3",
                          "val": 198
                      },
                      {
                          "key": "4",
                          "val": 0
                      },
                      {
                          "key": "5",
                          "val": 0
                      },
                      {
                          "key": "6",
                          "val": 6
                      },
                      {
                          "key": "7",
                          "val": 100
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:29:49.608718Z"
              },
              {
                  "id": 1354,
                  "grid_response_id": 302,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Railnet"
                      },
                      {
                          "key": "2",
                          "val": 188
                      },
                      {
                          "key": "3",
                          "val": 205
                      },
                      {
                          "key": "4",
                          "val": 205
                      },
                      {
                          "key": "5",
                          "val": 99.9
                      },
                      {
                          "key": "6",
                          "val": 100
                      },
                      {
                          "key": "7",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:31:16.866336Z"
              },
              {
                  "id": 1355,
                  "grid_response_id": 302,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "UTS & PRS"
                      },
                      {
                          "key": "2",
                          "val": 508
                      },
                      {
                          "key": "3",
                          "val": 576
                      },
                      {
                          "key": "4",
                          "val": 573
                      },
                      {
                          "key": "5",
                          "val": 98
                      },
                      {
                          "key": "6",
                          "val": 99.48
                      },
                      {
                          "key": "7",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:31:50.653931Z"
              },
              {
                  "id": 1356,
                  "grid_response_id": 302,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "FOIS"
                      },
                      {
                          "key": "2",
                          "val": 289
                      },
                      {
                          "key": "3",
                          "val": 258
                      },
                      {
                          "key": "4",
                          "val": 257
                      },
                      {
                          "key": "5",
                          "val": 98
                      },
                      {
                          "key": "6",
                          "val": 99.61
                      },
                      {
                          "key": "7",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:32:31.996699Z"
              },
              {
                  "id": 1357,
                  "grid_response_id": 302,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Exchnage"
                      },
                      {
                          "key": "2",
                          "val": 152
                      },
                      {
                          "key": "3",
                          "val": 213
                      },
                      {
                          "key": "4",
                          "val": 213
                      },
                      {
                          "key": "5",
                          "val": 98
                      },
                      {
                          "key": "6",
                          "val": 100
                      },
                      {
                          "key": "7",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:33:02.557689Z"
              },
              {
                  "id": 1358,
                  "grid_response_id": 303,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "FOIS"
                      },
                      {
                          "key": "2",
                          "val": 192
                      },
                      {
                          "key": "3",
                          "val": 191
                      },
                      {
                          "key": "4",
                          "val": 98
                      },
                      {
                          "key": "5",
                          "val": 99.48
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:33:46.02072Z"
              },
              {
                  "id": 1359,
                  "grid_response_id": 303,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "UTS/PRS"
                      },
                      {
                          "key": "2",
                          "val": 480
                      },
                      {
                          "key": "3",
                          "val": 477
                      },
                      {
                          "key": "4",
                          "val": 99
                      },
                      {
                          "key": "5",
                          "val": 99.38
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:34:10.665744Z"
              },
              {
                  "id": 1360,
                  "grid_response_id": 304,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "OFC"
                      },
                      {
                          "key": "2",
                          "val": 8
                      },
                      {
                          "key": "3",
                          "val": 3951.19
                      },
                      {
                          "key": "4",
                          "val": "<6 Hrs."
                      },
                      {
                          "key": "5",
                          "val": "7:08:00"
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:34:47.439354Z"
              },
              {
                  "id": 1361,
                  "grid_response_id": 304,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Quad"
                      },
                      {
                          "key": "2",
                          "val": 6
                      },
                      {
                          "key": "3",
                          "val": 4030.07
                      },
                      {
                          "key": "4",
                          "val": "<5 Hrs."
                      },
                      {
                          "key": "5",
                          "val": "4:02:00"
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:35:12.592421Z"
              },
              {
                  "id": 1362,
                  "grid_response_id": 305,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Block Ckt. Failure"
                      },
                      {
                          "key": "2",
                          "val": 344
                      },
                      {
                          "key": "3",
                          "val": 9
                      },
                      {
                          "key": "4",
                          "val": "<5 Hrs."
                      },
                      {
                          "key": "5",
                          "val": "3:18:00"
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:35:33.156841Z"
              },
              {
                  "id": 1363,
                  "grid_response_id": 305,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Data Logger Network Failure"
                      },
                      {
                          "key": "2",
                          "val": 466
                      },
                      {
                          "key": "3",
                          "val": 3
                      },
                      {
                          "key": "4",
                          "val": "<5 Hrs."
                      },
                      {
                          "key": "5",
                          "val": "4:12:00"
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:35:44.779092Z"
              },
              {
                  "id": 1364,
                  "grid_response_id": 306,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "FOIS"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 1365,
                  "grid_response_id": 306,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "UTS & PRS"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 1366,
                  "grid_response_id": 307,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Provision of IP-MPLS (No. of Stns)"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 1367,
                  "grid_response_id": 307,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Provision of IP Exchange "
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 1368,
                  "grid_response_id": 307,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Provision of No. of Stations to be provided with VoIP Control Communications"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 1369,
                  "grid_response_id": 307,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Provision of Lightening/Surge Protection (as per RDSO guideline for Telecom gears) *"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 1370,
                  "grid_response_id": 307,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Provision of  Earthing at Telecom Installations *"
                      },
                      {
                          "key": "2",
                          "val": 30
                      },
                      {
                          "key": "3",
                          "val": 2
                      },
                      {
                          "key": "4",
                          "val": 5
                      },
                      {
                          "key": "5",
                          "val": "SUR: 02 locations"
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:36:56.479297Z"
              },
              {
                  "id": 1371,
                  "grid_response_id": 307,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Provision of  Fire Alarm & Detection System *"
                      },
                      {
                          "key": "2",
                          "val": 101
                      },
                      {
                          "key": "3",
                          "val": 23
                      },
                      {
                          "key": "4",
                          "val": 103
                      },
                      {
                          "key": "5",
                          "val": "SUR:23 locations"
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:37:22.417315Z"
              },
              {
                  "id": 1372,
                  "grid_response_id": 307,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Provision of  Meggering of Quad Cable*"
                      },
                      {
                          "key": "2",
                          "val": 174
                      },
                      {
                          "key": "3",
                          "val": 23
                      },
                      {
                          "key": "4",
                          "val": 137
                      },
                      {
                          "key": "5",
                          "val": "NGP: 23 sections."
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:37:43.065139Z"
              },
              {
                  "id": 1373,
                  "grid_response_id": 307,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Provision of  Monitoring of CCTV equip at all stations through NMS/Dashboard*"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 1374,
                  "grid_response_id": 307,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Replacement of Old batteries Provided for PDMUX/STM-1/OFC Equipment *"
                      },
                      {
                          "key": "2",
                          "val": 70
                      },
                      {
                          "key": "3",
                          "val": null
                      },
                      {
                          "key": "4",
                          "val": 47
                      },
                      {
                          "key": "5",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:38:11.022876Z"
              },
              {
                  "id": 1375,
                  "grid_response_id": 307,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Replacement of Old batteries Provided for Exchanges *"
                      },
                      {
                          "key": "2",
                          "val": 1
                      },
                      {
                          "key": "3",
                          "val": null
                      },
                      {
                          "key": "4",
                          "val": 1
                      },
                      {
                          "key": "5",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:38:26.451989Z"
              },
              {
                  "id": 1376,
                  "grid_response_id": 307,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Replacement of Old batteries Provided for Walkie - Talkie (5W) *"
                      },
                      {
                          "key": "2",
                          "val": 2200
                      },
                      {
                          "key": "3",
                          "val": 124
                      },
                      {
                          "key": "4",
                          "val": 2995
                      },
                      {
                          "key": "5",
                          "val": "BB-105,NGP - 8,PA - 11"
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:39:05.024271Z"
              },
              {
                  "id": 1377,
                  "grid_response_id": 307,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Replacement of Old batteries Provided for VHF (25W) Sets. *"
                      },
                      {
                          "key": "2",
                          "val": 222
                      },
                      {
                          "key": "3",
                          "val": 9
                      },
                      {
                          "key": "4",
                          "val": 42
                      },
                      {
                          "key": "5",
                          "val": "BB: 05 Batteries,NGP : 04 Batteries."
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:39:44.964907Z"
              },
              {
                  "id": 1378,
                  "grid_response_id": 307,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Replacement of Old batteries Provided for Datacom Equipment's *"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 1379,
                  "grid_response_id": 307,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Replacement of Old batteries Provided for BTS (MTRC) *"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 1380,
                  "grid_response_id": 307,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Replacement of Old batteries Provided for IPIS *"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 1381,
                  "grid_response_id": 307,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Replacement of Old batteries Provided for CCTV *"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 1382,
                  "grid_response_id": 307,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Surrender/ Condemnation/replacement for VHF Sets *"
                      },
                      {
                          "key": "2",
                          "val": 250
                      },
                      {
                          "key": "3",
                          "val": 0
                      },
                      {
                          "key": "4",
                          "val": 504
                      },
                      {
                          "key": "5",
                          "val": "BB- 293 sets Condemned.,BSL-211 Sets Condemned."
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:40:32.208709Z"
              },
              {
                  "id": 1383,
                  "grid_response_id": 307,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Surrender/ Condemnation/replacement for V-SATs *"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 1384,
                  "grid_response_id": 307,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Rail Madad complaints redressal (Time Taken) Average complaints redressal time "
                      },
                      {
                          "key": "2",
                          "val": 120
                      },
                      {
                          "key": "3",
                          "val": ""
                      },
                      {
                          "key": "4",
                          "val": null
                      },
                      {
                          "key": "5",
                          "val": "42 complaints disposed."
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:42:56.525015Z"
              },
              {
                  "id": 1933,
                  "grid_response_id": 308,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Payment to RCIL (HQ)"
                      },
                      {
                          "key": "2",
                          "val": "0"
                      },
                      {
                          "key": "3",
                          "val": null
                      },
                      {
                          "key": "4",
                          "val": null
                      },
                      {
                          "key": "5",
                          "val": 35374
                      },
                      {
                          "key": "6",
                          "val": 100
                      }
                  ],
                  "created_by": 3,
                  "updated_by": 3,
                  "created_dt": "2024-05-11T12:44:03.132224Z",
                  "updated_dt": "2024-05-11T12:45:14.480642Z"
              },
              {
                  "id": 1934,
                  "grid_response_id": 308,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Payment to RCIL (DIV)"
                      },
                      {
                          "key": "2",
                          "val": null
                      },
                      {
                          "key": "3",
                          "val": null
                      },
                      {
                          "key": "4",
                          "val": 2347
                      },
                      {
                          "key": "5",
                          "val": 5098
                      },
                      {
                          "key": "6",
                          "val": 100
                      }
                  ],
                  "created_by": 3,
                  "updated_by": 3,
                  "created_dt": "2024-05-11T12:45:02.347512Z",
                  "updated_dt": "2024-05-11T12:45:02.347512Z"
              },
              {
                  "id": 1385,
                  "grid_response_id": 309,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "PH-33"
                      },
                      {
                          "key": "2",
                          "val": 101609
                      },
                      {
                          "key": "3",
                          "val": 332011
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:45:37.157329Z"
              },
              {
                  "id": 1386,
                  "grid_response_id": 309,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "PH-64"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 1387,
                  "grid_response_id": 309,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "PH-29"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 1388,
                  "grid_response_id": 309,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "PH-53"
                      },
                      {
                          "key": "2",
                          "val": 52300
                      },
                      {
                          "key": "3",
                          "val": 38236
                      }
                  ],
                  "created_by": null,
                  "updated_by": 3,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-05-11T12:45:49.217617Z"
              },
              {
                  "id": 1935,
                  "grid_response_id": 310,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Mumbai"
                      },
                      {
                          "key": "2",
                          "val": ""
                      },
                      {
                          "key": "3",
                          "val": "CSTM - Kurla (ML)"
                      },
                      {
                          "key": "4",
                          "val": [
                              "Yes"
                          ]
                      },
                      {
                          "key": "5",
                          "val": null
                      },
                      {
                          "key": "6",
                          "val": 100
                      }
                  ],
                  "created_by": 3,
                  "updated_by": 3,
                  "created_dt": "2024-05-11T12:46:42.449711Z",
                  "updated_dt": "2024-05-11T12:46:42.449711Z"
              },
              {
                  "id": 59496,
                  "grid_response_id": 310,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Mumbai"
                      },
                      {
                          "key": "2",
                          "val": ""
                      },
                      {
                          "key": "3",
                          "val": "Kurla - Kalyan"
                      },
                      {
                          "key": "4",
                          "val": [
                              "Yes"
                          ]
                      },
                      {
                          "key": "5",
                          "val": 0
                      },
                      {
                          "key": "6",
                          "val": 100
                      }
                  ],
                  "created_by": 104,
                  "updated_by": 104,
                  "created_dt": "2024-05-13T07:02:29.935146Z",
                  "updated_dt": "2024-05-13T07:02:29.935146Z"
              },
              {
                  "id": 59497,
                  "grid_response_id": 310,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Mumbai"
                      },
                      {
                          "key": "2",
                          "val": ""
                      },
                      {
                          "key": "3",
                          "val": "Kalyan - Igatpuri (NE)"
                      },
                      {
                          "key": "4",
                          "val": [
                              "Yes"
                          ]
                      },
                      {
                          "key": "5",
                          "val": 0
                      },
                      {
                          "key": "6",
                          "val": 100
                      }
                  ],
                  "created_by": 104,
                  "updated_by": 104,
                  "created_dt": "2024-05-13T07:02:56.479378Z",
                  "updated_dt": "2024-05-13T09:33:11.272853Z"
              },
              {
                  "id": 59498,
                  "grid_response_id": 310,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Mumbai"
                      },
                      {
                          "key": "2",
                          "val": ""
                      },
                      {
                          "key": "3",
                          "val": "Kalyan - Lonavala, Karjat-Khopoli (SE)"
                      },
                      {
                          "key": "4",
                          "val": [
                              "Yes"
                          ]
                      },
                      {
                          "key": "5",
                          "val": 0
                      },
                      {
                          "key": "6",
                          "val": 100
                      }
                  ],
                  "created_by": 104,
                  "updated_by": 104,
                  "created_dt": "2024-05-13T07:03:22.221432Z",
                  "updated_dt": "2024-05-13T09:33:19.360087Z"
              },
              {
                  "id": 59499,
                  "grid_response_id": 310,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Mumbai"
                      },
                      {
                          "key": "2",
                          "val": null
                      },
                      {
                          "key": "3",
                          "val": "CSTM-Bandra (W.Rly), CSTM-Panvel and Thane-Vashi (HB)"
                      },
                      {
                          "key": "4",
                          "val": [
                              "Yes"
                          ]
                      },
                      {
                          "key": "5",
                          "val": 0
                      },
                      {
                          "key": "6",
                          "val": 100
                      }
                  ],
                  "created_by": 104,
                  "updated_by": 104,
                  "created_dt": "2024-05-13T07:04:10.724094Z",
                  "updated_dt": "2024-05-13T07:04:10.724094Z"
              },
              {
                  "id": 59500,
                  "grid_response_id": 310,
                  "row": [
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "0",
                          "val": "CR"
                      },
                      {
                          "key": "1",
                          "val": "Mumbai"
                      },
                      {
                          "key": "2",
                          "val": ""
                      },
                      {
                          "key": "3",
                          "val": "Diva-Vasai Road-Panvel-Jasai (DBRP TFC-1)"
                      },
                      {
                          "key": "4",
                          "val": [
                              "Yes"
                          ]
                      },
                      {
                          "key": "5",
                          "val": 0
                      },
                      {
                          "key": "6",
                          "val": 100
                      }
                  ],
                  "created_by": 104,
                  "updated_by": 104,
                  "created_dt": "2024-05-13T07:19:40.987548Z",
                  "updated_dt": "2024-05-13T07:19:40.987548Z"
              },
              {
                  "id": 36499,
                  "grid_response_id": 7480,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "OFC"
                      },
                      {
                          "key": "3",
                          "val": "99.98"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36500,
                  "grid_response_id": 7480,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Quad Cable"
                      },
                      {
                          "key": "3",
                          "val": "99.98"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36501,
                  "grid_response_id": 7480,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "RE Cable (Rly.)"
                      },
                      {
                          "key": "3",
                          "val": "99.98"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36502,
                  "grid_response_id": 7480,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "BSNL O/H"
                      },
                      {
                          "key": "3",
                          "val": "98"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36503,
                  "grid_response_id": 7480,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Railway O/H"
                      },
                      {
                          "key": "3",
                          "val": "98"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36504,
                  "grid_response_id": 7481,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "A"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36505,
                  "grid_response_id": 7481,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "B"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36506,
                  "grid_response_id": 7481,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "C"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36507,
                  "grid_response_id": 7481,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Dspl"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36508,
                  "grid_response_id": 7481,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "D"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36509,
                  "grid_response_id": 7481,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "E"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36510,
                  "grid_response_id": 7482,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Railnet"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36511,
                  "grid_response_id": 7482,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "UTS/PRS"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36512,
                  "grid_response_id": 7482,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "FOIS"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36513,
                  "grid_response_id": 7482,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Exchnage"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36514,
                  "grid_response_id": 7483,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Railnet"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36515,
                  "grid_response_id": 7483,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "UTS & PRS"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36516,
                  "grid_response_id": 7483,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "FOIS"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36517,
                  "grid_response_id": 7483,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Exchnage"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36518,
                  "grid_response_id": 7484,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "FOIS"
                      },
                      {
                          "key": "4",
                          "val": "98.00"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36519,
                  "grid_response_id": 7484,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "UTS/PRS"
                      },
                      {
                          "key": "4",
                          "val": "99.00"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36520,
                  "grid_response_id": 7485,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "OFC"
                      },
                      {
                          "key": "4",
                          "val": "<6 Hrs."
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36521,
                  "grid_response_id": 7485,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Quad"
                      },
                      {
                          "key": "4",
                          "val": "<5 Hrs."
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36522,
                  "grid_response_id": 7486,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Block Ckt. Failure"
                      },
                      {
                          "key": "4",
                          "val": "<5 Hrs."
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36523,
                  "grid_response_id": 7486,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Data Logger Network Failure"
                      },
                      {
                          "key": "4",
                          "val": "<5 Hrs."
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36524,
                  "grid_response_id": 7487,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "FOIS"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36525,
                  "grid_response_id": 7487,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "UTS & PRS"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36526,
                  "grid_response_id": 7488,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Provision of IP-MPLS (No. of Stns)"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36527,
                  "grid_response_id": 7488,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Provision of IP Exchange "
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36528,
                  "grid_response_id": 7488,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Provision of No. of Stations to be provided with VoIP Control Communications"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36529,
                  "grid_response_id": 7488,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Provision of Lightening/Surge Protection (as per RDSO guideline for Telecom gears) *"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36530,
                  "grid_response_id": 7488,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Provision of  Earthing at Telecom Installations *"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36531,
                  "grid_response_id": 7488,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Provision of  Fire Alarm & Detection System *"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36532,
                  "grid_response_id": 7488,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Provision of  Meggering of Quad Cable*"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36533,
                  "grid_response_id": 7488,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Provision of  Monitoring of CCTV equip at all stations through NMS/Dashboard*"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36534,
                  "grid_response_id": 7488,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Replacement of Old batteries Provided for PDMUX/STM-1/OFC Equipment *"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36535,
                  "grid_response_id": 7488,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Replacement of Old batteries Provided for Exchanges *"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36536,
                  "grid_response_id": 7488,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Replacement of Old batteries Provided for Walkie - Talkie (5W) *"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36537,
                  "grid_response_id": 7488,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Replacement of Old batteries Provided for VHF (25W) Sets. *"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36538,
                  "grid_response_id": 7488,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Replacement of Old batteries Provided for Datacom Equipment's *"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36539,
                  "grid_response_id": 7488,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Replacement of Old batteries Provided for BTS (MTRC) *"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36540,
                  "grid_response_id": 7488,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Replacement of Old batteries Provided for IPIS *"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36541,
                  "grid_response_id": 7488,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Replacement of Old batteries Provided for CCTV *"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36542,
                  "grid_response_id": 7488,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Surrender/ Condemnation/replacement for VHF Sets *"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36543,
                  "grid_response_id": 7488,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Surrender/ Condemnation/replacement for V-SATs *"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36544,
                  "grid_response_id": 7488,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "Rail Madad complaints redressal (Time Taken) Average complaints redressal time "
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36545,
                  "grid_response_id": 7490,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "PH-33"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36546,
                  "grid_response_id": 7490,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "PH-64"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36547,
                  "grid_response_id": 7490,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "PH-29"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              },
              {
                  "id": 36548,
                  "grid_response_id": 7490,
                  "row": [
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "0",
                          "val": "ECR"
                      },
                      {
                          "key": "1",
                          "val": "PH-53"
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "2024-02-29T18:30:00Z",
                  "updated_dt": "2024-02-29T18:30:00Z"
              }
          ]
      },
      {
          "id": 0,
          "annexure_instance_id": null,
          "grid_definition_id": 35,
          "rows": [
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      null,
                      {
                          "key": "1",
                          "val": "OFC"
                      },
                      {
                          "key": "2",
                          "val": null
                      },
                      {
                          "key": "3",
                          "val": null
                      },
                      null,
                      null,
                      null
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              },
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      null,
                      {
                          "key": "1",
                          "val": "Quad Cable"
                      },
                      {
                          "key": "3",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              },
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      null,
                      {
                          "key": "1",
                          "val": "RE Cable (Rly.)"
                      },
                      {
                          "key": "3",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              },
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      null,
                      {
                          "key": "1",
                          "val": "BSNL O/H"
                      },
                      {
                          "key": "3",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              },
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      null,
                      {
                          "key": "1",
                          "val": "Railway O/H"
                      },
                      {
                          "key": "3",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              }
          ]
      },
      {
          "id": 0,
          "annexure_instance_id": null,
          "grid_definition_id": 27,
          "rows": [
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      null,
                      null,
                      {
                          "key": "1",
                          "val": "OFC"
                      },
                      {
                          "key": "2",
                          "val": null
                      },
                      {
                          "key": "3",
                          "val": null
                      },
                      {
                          "key": "4",
                          "val": null
                      },
                      {
                          "key": "5",
                          "val": null
                      },
                      {
                          "key": "6",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              },
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      null,
                      null,
                      {
                          "key": "1",
                          "val": "Quad Cable"
                      },
                      {
                          "key": "3",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              },
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      null,
                      null,
                      {
                          "key": "1",
                          "val": "RE Cable (Rly.)"
                      },
                      {
                          "key": "3",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              },
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      null,
                      null,
                      {
                          "key": "1",
                          "val": "BSNL O/H"
                      },
                      {
                          "key": "3",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              },
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      null,
                      null,
                      {
                          "key": "1",
                          "val": "Railway O/H"
                      },
                      {
                          "key": "3",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              }
          ]
      },
      {
          "id": 0,
          "annexure_instance_id": null,
          "grid_definition_id": 30,
          "rows": [
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      null,
                      null,
                      {
                          "key": "1",
                          "val": "OFC"
                      },
                      {
                          "key": "2",
                          "val": null
                      },
                      {
                          "key": "3",
                          "val": null
                      },
                      {
                          "key": "4",
                          "val": "99.998"
                      },
                      {
                          "key": "5",
                          "val": null
                      },
                      null
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              },
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      null,
                      null,
                      {
                          "key": "1",
                          "val": "Quad Cable"
                      },
                      {
                          "key": "3",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              },
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      null,
                      null,
                      {
                          "key": "1",
                          "val": "RE Cable (Rly.)"
                      },
                      {
                          "key": "3",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              },
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      null,
                      null,
                      {
                          "key": "1",
                          "val": "BSNL O/H"
                      },
                      {
                          "key": "3",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              },
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      null,
                      null,
                      {
                          "key": "1",
                          "val": "Railway O/H"
                      },
                      {
                          "key": "3",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              }
          ]
      },
      {
          "id": 0,
          "annexure_instance_id": null,
          "grid_definition_id": 32,
          "rows": [
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      null,
                      null,
                      {
                          "key": "1",
                          "val": "OFC"
                      },
                      {
                          "key": "2",
                          "val": null
                      },
                      {
                          "key": "3",
                          "val": null
                      },
                      {
                          "key": "4",
                          "val": null
                      },
                      {
                          "key": "5",
                          "val": null
                      },
                      {
                          "key": "6",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              },
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      null,
                      null,
                      {
                          "key": "1",
                          "val": "Quad Cable"
                      },
                      {
                          "key": "3",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              },
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      null,
                      null,
                      {
                          "key": "1",
                          "val": "RE Cable (Rly.)"
                      },
                      {
                          "key": "3",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              },
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      null,
                      null,
                      {
                          "key": "1",
                          "val": "BSNL O/H"
                      },
                      {
                          "key": "3",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              },
              {
                  "id": 0,
                  "grid_response_id": null,
                  "row": [
                      null,
                      null,
                      {
                          "key": "1",
                          "val": "Railway O/H"
                      },
                      {
                          "key": "3",
                          "val": null
                      }
                  ],
                  "created_by": null,
                  "updated_by": null,
                  "created_dt": "0001-01-01T00:00:00Z",
                  "updated_dt": "0001-01-01T00:00:00Z"
              }
          ]
      }
  ]
}